var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"radius-0 border-white",attrs:{"solo":"","outlined":"","flat":"","hide-details":"","label":"Search","prepend-inner-icon":"mdi-magnify","color":"primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }